export const useTimelineMarkers = (startHour: number, endHour: number, zoom: number) => {
  const majorMarkers = []
  const subMarkers = []

  for (let hour = startHour; hour <= endHour; hour++) {
    majorMarkers.push({
      hour: hour,
      minutes: 0,
      isMajor: true,
      label: `${hour.toString().padStart(2, '0')}:00`,
      relativePosition: 0,
    })

    if (hour === endHour) break

    // Add intermediate markers based on zoom
    if (zoom > 1 && zoom < 2) {
      subMarkers.push({
        hour: hour,
        minutes: 30,
        isMajor: false,
        label: `${hour.toString().padStart(2, '0')}:30`,
        relativePosition: 0.5, // 50% of the hour cell
      })
    }
    else if (zoom >= 2 && zoom < 4) {
      for (let minute = 15; minute < 60; minute += 15) {
        subMarkers.push({
          hour: hour,
          minutes: minute,
          isMajor: false,
          label: `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`,
          relativePosition: minute / 60,
        })
      }
    }
    else if (zoom >= 4 && zoom < 5) {
      for (let minute = 10; minute < 60; minute += 10) {
        subMarkers.push({
          hour: hour,
          minutes: minute,
          isMajor: false,
          label: `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`,
          relativePosition: minute / 60,
        })
      }
    }
    else if (zoom >= 5) {
      for (let minute = 5; minute < 60; minute += 5) {
        subMarkers.push({
          hour: hour,
          minutes: minute,
          isMajor: false,
          label: `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`,
          relativePosition: minute / 60,
        })
      }
    }
  }

  return [majorMarkers.sort((a, b) => (a.hour + a.minutes / 60) - (b.hour + b.minutes / 60)), subMarkers]
}